

















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import {OperatorType} from '@/features/contacts/models/operatorTypes';
@Component({
	components: {
		DropDownMenu
	}
})
export default class JoinOperatorPicker extends Vue {
	@Prop() public value: string;
	@Prop({default: false}) public disabled: boolean;

	public hovered: boolean = false;

	public selectedOperator: OperatorType = OperatorType.And;
	public active: boolean = false;

	@Watch('value', { immediate: true })
	public onValueChanged(value: string, previous: string) {
		this.selectedOperator = value as OperatorType;
	}

	public getJoinOperators(): OperatorType[] {
		return [OperatorType.And, OperatorType.Or];
	}

	public selectOperator(type: OperatorType) {
		if (this.disabled) {
			return;
		}

		if (this.selectedOperator !== type) {
			this.$emit('updated-operator', type);
		}
		this.selectedOperator = type;
		this.active = false;
	}

	public setActive(isOpen: boolean) {
		if (this.disabled) {
			return;
		}

		this.active = isOpen;
	}

	public onUpdatedHoverState(hover: boolean) {
		this.$emit('updated-hover-state', hover);
	}
}
